import React from 'react'
import Schedules from './Schedules'
import { Box, Button, Divider } from '@mui/material'
import { t } from 'i18next'
import { schedules } from '../../shared/types/schedule.type'
import { RepportType } from "../../pages/settings/notifications";
import StableSchedule from './StableSchedule'

type NewChannelStep4Props = {
    step: number,
    onSave: () => void,
    onBack: () => void,
    schedules: Partial<schedules>[],
    onScheduleChange: ((schedules: Partial<schedules>[]) => void),
    repportType: RepportType,
    lastXHours?: number,
    setLastXHours: (value: number) => void
}

function NewConfigStep4({ repportType, step, onSave, onBack, schedules, onScheduleChange, lastXHours, setLastXHours }: NewChannelStep4Props) {
    return (
        <Box>
            {
                repportType !== 'STABLE_REPPORT' ?

                    <Schedules
                        repportType={repportType}
                        schedules={schedules}
                        lastXHours={lastXHours}
                        setLastXHours={setLastXHours}
                        onScheduleChange={onScheduleChange}></Schedules>

                    : <StableSchedule
                        schedules={schedules}
                        onScheduleChange={onScheduleChange}
                    />
            }
            <Divider></Divider>
            <Box display={'flex'} justifyContent={'space-between'} mt={1}>
                <Button onClick={onBack} disabled={step === 0} color='inherit'>{t('button:back')}</Button>
                <Button onClick={onSave} variant='contained'>{t('button:next')}</Button>
            </Box>
        </Box>
    )
}

export default NewConfigStep4